{
  "PROFILE_SETTINGS": {
    "LINK": "Ajustes del perfil",
    "TITLE": "Ajustes del perfil",
    "BTN_TEXT": "Actualizar perfil",
    "DELETE_AVATAR": "Eliminar avatar",
    "AVATAR_DELETE_SUCCESS": "El avatar se ha eliminado correctamente",
    "AVATAR_DELETE_FAILED": "Se ha producido un error al eliminar el avatar, inténtelo de nuevo",
    "UPDATE_SUCCESS": "Tu perfil se ha actualizado correctamente",
    "PASSWORD_UPDATE_SUCCESS": "Su contraseña se ha cambiado correctamente",
    "AFTER_EMAIL_CHANGED": "Su perfil ha sido actualizado con éxito, por favor inicie sesión de nuevo cuando sus credenciales de inicio de sesión se hayan cambiado",
    "FORM": {
      "PICTURE": "Foto de perfil",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Imagen de la firma de correo electrónico",
        "HINT": "Se utiliza en las firmas de correo electrónico. {'{{'}email_signature_picture{'}}'} se reemplaza por la URL de esta imagen (no una etiqueta de imagen) — úsala como fuente de imagen (el atributo src de una etiqueta img) en tu firma o en la firma de la bandeja de entrada. Si no se define, no se inserta nada.",
        "DELETE_SUCCESS": "La imagen de la firma de correo electrónico se ha eliminado correctamente",
        "DELETE_FAILED": "Se ha producido un error al eliminar la imagen de la firma de correo electrónico, inténtalo de nuevo"
      },
      "AVATAR": "Imagen de perfil",
      "ERROR": "Por favor, corrija los errores de formulario",
      "REMOVE_IMAGE": "Eliminar",
      "UPLOAD_IMAGE": "Subir imagen",
      "UPDATE_IMAGE": "Actualizar imagen",
      "PROFILE_SECTION": {
        "TITLE": "Perfil",
        "NOTE": "Su dirección de correo electrónico es su identidad y se utiliza para iniciar sesión."
      },
      "SEND_MESSAGE": {
        "TITLE": "Tecla rápida para enviar mensajes",
        "NOTE": "Puede seleccionar una tecla de acceso rápido (Enter o Cmd/Ctrl+Enter) basándose en su preferencia de escritura.",
        "UPDATE_SUCCESS": "Su configuración se ha actualizado correctamente",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Envía mensajes presionando la tecla Intro en lugar de hacer clic en el botón Enviar."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Envía mensajes pulsando Cmd/Ctrl + tecla Intro en lugar de hacer clic en el botón Enviar."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Personaliza la apariencia de tu panel de control.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Predeterminado",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Idioma del panel",
          "NOTE": "Sobrescribe el idioma de la cuenta para tu propio panel. Dejar vacío para usar el predeterminado de la cuenta.",
          "USE_ACCOUNT_DEFAULT": "Usar el predeterminado de la cuenta",
          "API_SUCCESS": "El idioma de tu panel se ha actualizado correctamente",
          "API_ERROR": "Hay un error al actualizar el idioma del panel, por favor inténtalo de nuevo"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Idioma del mensaje",
          "NOTE": "Elige si mostrar los mensajes originales o sus traducciones",
          "ORIGINAL": "Original",
          "TRANSLATED": "Traducido"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Comportamiento al pegar",
          "NOTE": "Elige cómo se procesa el contenido pegado al redactar mensajes",
          "UPDATE_SUCCESS": "Tu configuración de pegado se ha actualizado correctamente",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Conservar todo el formato",
              "DESCRIPTION": "Conserva todo el formato incluyendo tablas, estilos y otros elementos HTML al pegar contenido."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Solo texto con enlaces",
              "DESCRIPTION": "Convierte a texto plano pero conserva los enlaces clicables al pegar contenido."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Solo texto plano",
              "DESCRIPTION": "Elimina todo el formato y convierte a texto plano al pegar contenido."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Altura del cuadro de respuesta",
          "NOTE": "Establece la altura mínima del cuadro de respuesta como un porcentaje de la altura de la pantalla. Se aplica solo a las conversaciones por correo electrónico.",
          "UPDATE_SUCCESS": "Tu configuración de altura del cuadro de respuesta se ha actualizado correctamente",
          "PERCENT_LABEL": "Altura (% de la altura de la pantalla)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Predeterminado",
              "DESCRIPTION": "El cuadro de respuesta comienza pequeño y crece a medida que escribes."
            },
            "CUSTOM": {
              "HEADING": "Personalizado",
              "DESCRIPTION": "El cuadro de respuesta siempre ocupa al menos el porcentaje elegido de la altura de la pantalla."
            }
          }
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Firma de mensaje personal",
        "NOTE": "Crea una firma de mensaje única para que aparezca al final de cada mensaje que envíes desde cualquier bandeja de entrada. También puede incluir una imagen en línea, que es soportada en las bandejas de entrada de live-chat, correo electrónico y API.",
        "BTN_TEXT": "Guardar firma de mensaje",
        "API_ERROR": "¡No se pudo guardar la firma! Inténtalo de nuevo",
        "API_SUCCESS": "Firma guardada correctamente",
        "IMAGE_UPLOAD_ERROR": "¡No se pudo subir la imagen! Intente nuevamente",
        "IMAGE_UPLOAD_SUCCESS": "Imagen agregada satisfactoriamente. Por favor haga clic en salvar para guardar la firma",
        "IMAGE_UPLOAD_SIZE_ERROR": "El tamaño de la imagen debe ser menor que {size}MB",
        "DESCRIPTION": "Crea una firma de mensaje única que aparezca al final de cada correo que envíes. También puedes incluir una imagen en línea."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Firma del mensaje",
        "ERROR": "La firma del mensaje no puede estar vacía",
        "PLACEHOLDER": "Introduzca aquí su firma de mensaje personal."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Contraseña",
        "NOTE": "Actualizar tu contraseña restablecería tus entradas en varios dispositivos.",
        "BTN_TEXT": "Cambiar contraseña"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Token de acceso",
        "NOTE": "Este token puede ser usado si estás construyendo una integración basada en API",
        "COPY": "Copiar",
        "REGENERATE": "Regenerar",
        "REGENERATE_SUCCESS": "Token de acceso regenerado correctamente. Por favor, actualiza cualquier integración que use el token antiguo.",
        "REGENERATE_CONFIRM_TITLE": "¿Regenerar token de acceso?",
        "REGENERATE_CONFIRM_MESSAGE": "Esto invalidará el token actual. Cualquier integración que use el token antiguo dejará de funcionar."
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Alertas de audio",
        "NOTE": "Active las notificaciones de sonido en el tablero para los mensajes nuevos y conversaciones.",
        "PLAY": "Reproducir sonido",
        "ALERT_TYPES": {
          "NONE": "Ninguna",
          "MINE": "Asignado",
          "ALL": "Todos",
          "ASSIGNED": "Conversaciones asignadas",
          "UNASSIGNED": "Conversaciones sin asignar",
          "NOTME": "Conversaciones abiertas asignadas a otros"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "No ha seleccionado ninguna opción, no recibirá ninguna alerta de audio.",
          "ASSIGNED": "Recibirás alertas sobre las conversaciones que se te hayan asignado.",
          "UNASSIGNED": "Recibirás alertas sobre cualquier conversación no asignada.",
          "NOTME": "Recibirás alertas sobre las conversaciones asignadas a otros.",
          "ASSIGNED+UNASSIGNED": "Recibirás alertas de tus conversaciones asignadas y de las no atendidas.",
          "ASSIGNED+NOTME": "Recibirás alertas sobre las conversaciones que te han sido asignadas a ti y a otros, pero no sobre las no asignadas.",
          "NOTME+UNASSIGNED": "Recibirás alertas de conversaciones desatendidas y de las asignadas a otros.",
          "ASSIGNED+NOTME+UNASSIGNED": "Recibirás alertas de todas las conversaciones."
        },
        "ALERT_TYPE": {
          "TITLE": "Eventos de alerta para conversaciones",
          "NONE": "Ninguna",
          "ASSIGNED": "Conversaciones asignadas",
          "ALL_CONVERSATIONS": "Todas las conversaciones"
        },
        "DEFAULT_TONE": {
          "TITLE": "Tono de alerta:"
        },
        "CONDITIONS": {
          "TITLE": "Condiciones de alerta:",
          "CONDITION_ONE": "Enviar alertas de audio sólo si la ventana del navegador no está activa",
          "CONDITION_TWO": "Enviar alertas cada 30s hasta que todas las conversaciones asignadas sean leídas"
        },
        "SOUND_PERMISSION_ERROR": "La reproducción automática está desactivada en su navegador. Para escuchar las alertas automáticamente, habilite el permiso de sonido en la configuración de su navegador o interactúe con la página.",
        "READ_MORE": "Leer más"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificaciones por email",
        "NOTE": "Actualiza tus preferencias de notificación por correo electrónico aquí",
        "CONVERSATION_ASSIGNMENT": "Enviar notificaciones por correo electrónico cuando se me ha asignado una conversación",
        "CONVERSATION_CREATION": "Enviar notificaciones por correo electrónico cuando se crea una nueva conversación",
        "CONVERSATION_MENTION": "Enviar notificaciones por correo electrónico cuando sea mencionado en una conversación",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Envirar notificaciones por correo electrónico cuando un nuevo mensaje es creado en una conversación asignada",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Enviar notificaciones por correo electrónico cuando se crea un nuevo mensaje en una conversación participante",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Preferencias de notificación",
        "TYPE_TITLE": "Tipo de notificación",
        "EMAIL": "E-mail",
        "PUSH": "Notificación push",
        "TYPES": {
          "CONVERSATION_CREATED": "Se ha creado una nueva conversación",
          "CONVERSATION_ASSIGNED": "Se te ha asignado una conversación",
          "CONVERSATION_MENTION": "Has sido mencionado en una conversación",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Un nuevo mensaje se ha creado en una conversación asignada",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Un nuevo mensaje se ha creado en una conversación en la que participas",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "Una conversación carece de resolución SLA",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Se crea un nuevo mensaje en una conversación sin agente disponible"
        },
        "BROWSER_PERMISSION": "Activa las notificaciones push en tu navegador para que puedas recibirlas",
        "ALLOW_NOTIFICATION_DURING_CALL": "Permitir notificaciones push mientras estás en una llamada",
        "TEST_PUSH": "Probar",
        "TESTING": "Probando...",
        "TEST_PUSH_DESCRIPTION": "Enviar notificaciones de prueba para verificar tu configuración",
        "TEST_NOTIFICATION_ERROR": "Error al enviar la notificación de prueba. Por favor, inténtalo de nuevo.",
        "TEST_LOCAL_TITLE": "Notificación de prueba (Local)",
        "TEST_LOCAL_BODY": "¡Esta es una notificación local del navegador. Si la ves, las notificaciones del navegador están funcionando!"
      },
      "API": {
        "UPDATE_SUCCESS": "Sus preferencias de notificación se actualizaron correctamente",
        "UPDATE_ERROR": "Se ha producido un error al actualizar las preferencias, inténtelo de nuevo"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificaciones push",
        "NOTE": "Actualize sus preferencias de notificaciones push aquí",
        "CONVERSATION_ASSIGNMENT": "Enviar notificaciones push cuando se me ha asignado una conversación",
        "CONVERSATION_CREATION": "Enviar notificaciones push cuando se crea una nueva conversación",
        "CONVERSATION_MENTION": "Enviar notificaciones push cuando sea mencionado en una conversación",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Enviar notificaciones push cuando un nuevo mensaja es creadao en una conversación asignada",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Enviar notificaciones push cuando se crea un nuevo mensaje en una conversación participante",
        "HAS_ENABLED_PUSH": "Ha habilitado notificaciones push para este navegador.",
        "REQUEST_PUSH": "Habilitar notificaciones push",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Imagen de perfil"
      },
      "NAME": {
        "LABEL": "Su nombre completo",
        "ERROR": "Introduce un nombre válido por favor",
        "PLACEHOLDER": "Introduzca su nombre completo por favor"
      },
      "DISPLAY_NAME": {
        "LABEL": "Nombre a mostrar",
        "ERROR": "Introduzca un nombre válido por favor",
        "PLACEHOLDER": "Introduzca un nombre a mostrar por favor, esto se mostrará en las conversaciones"
      },
      "AVAILABILITY": {
        "LABEL": "Disponibilidad",
        "STATUS": {
          "ONLINE": "En línea",
          "BUSY": "Ocupado",
          "OFFLINE": "Desconectado"
        },
        "SET_AVAILABILITY_SUCCESS": "La disponibilidad se ha establecido con éxito",
        "SET_AVAILABILITY_ERROR": "No se pudo establecer la disponibilidad, inténtelo de nuevo"
      },
      "EMAIL": {
        "LABEL": "Tu dirección de correo",
        "ERROR": "Por favor, introduzca una dirección de correo válida",
        "PLACEHOLDER": "Por favor, introduzca su dirección de correo electrónico, esto se mostrará en las conversaciones"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Contraseña actual",
        "ERROR": "Por favor, introduzca su contraseña actual",
        "PLACEHOLDER": "Por favor, introduzca su contraseña actual"
      },
      "PASSWORD": {
        "LABEL": "Nueva contraseña",
        "ERROR": "Por favor, introduzca una contraseña de longitud 6 o más",
        "PLACEHOLDER": "Por favor, introduzca una nueva contraseña"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Confirmar nueva contraseña",
        "ERROR": "Confirmar contraseña debe coincidir con la contraseña",
        "PLACEHOLDER": "Por favor, vuelva a introducir su nueva contraseña"
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Navegar automáticamente a la siguiente conversación",
        "NOTE": "Cambiar automáticamente a la siguiente conversación abierta tras resolver la actual",
        "UPDATE_SUCCESS": "Configuración de navegación automática actualizada correctamente"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Formato de vista previa de correo electrónico en la lista de conversaciones",
        "NOTE": "Elige qué se muestra en la lista de conversaciones para conversaciones de bandejas de entrada de correo electrónico",
        "SUBJECT": "Asunto",
        "SUBJECT_WITH_NOTE": "Asunto y último mensaje si es una nota privada",
        "UPDATE_SUCCESS": "Configuración de vista previa de correo electrónico actualizada correctamente"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Desactivar atajos de teclado",
        "NOTE": "Desactivar todos los atajos de teclado en toda la aplicación",
        "UPDATE_SUCCESS": "Configuración de atajos de teclado actualizada correctamente"
      },
      "FOLDER_ORDER": {
        "TITLE": "Orden de carpetas",
        "NOTE": "Personaliza el orden en el que las carpetas (vistas personalizadas) aparecen en la barra lateral. Arrastra y suelta para reordenar.",
        "NO_FOLDERS": "No se encontraron carpetas personalizadas. Crea carpetas para organizar tus conversaciones."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Configuración de la barra lateral",
        "NOTE": "Personaliza qué secciones aparecen en la barra lateral de conversaciones.",
        "SAVE_BUTTON": "Guardar configuración",
        "UPDATE_SUCCESS": "Configuración de la barra lateral actualizada correctamente",
        "UPDATE_ERROR": "Hubo un error al actualizar la configuración de la barra lateral, por favor inténtalo de nuevo",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Todas las conversaciones",
          "ALL_CONVERSATIONS_DESC": "Mostrar el elemento Todas las conversaciones en la barra lateral",
          "INBOX": "Bandeja de entrada",
          "INBOX_DESC": "Mostrar la bandeja de entrada principal con notificaciones no leídas",
          "CONVERSATION_GROUPS": "Menciones y sin atender",
          "CONVERSATION_GROUPS_DESC": "Mostrar grupos de menciones y conversaciones sin atender",
          "FOLDERS": "Carpetas",
          "FOLDERS_DESC": "Mostrar vistas personalizadas (carpetas) para conversaciones organizadas",
          "TEAMS": "Equipos",
          "TEAMS_DESC": "Mostrar conversaciones filtradas por asignaciones de equipo",
          "CHANNELS": "Bandejas de entrada",
          "CHANNELS_DESC": "Mostrar conversaciones filtradas por bandeja de entrada",
          "LABELS": "Etiquetas",
          "LABELS_DESC": "Mostrar conversaciones filtradas por etiquetas"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Configuración del teléfono",
        "NOTE": "Introduce las credenciales de inicio de sesión de tu sistema PBX.",
        "USERNAME": "Nombre de usuario",
        "PASSWORD": "Contraseña",
        "SUBMIT": "Guardar",
        "USERNAME_INVALID": "El nombre de usuario solo puede contener letras, dígitos y . _ - + — sin espacios ni dirección de correo electrónico.",
        "API": {
          "USERNAME_INVALID": "El nombre de usuario no es un nombre de usuario SIP válido. Usa solo letras, dígitos y . _ - + — sin espacios ni dirección de correo electrónico.",
          "USERNAME_TAKEN": "Este nombre de usuario ya está siendo utilizado por otro agente en esta cuenta."
        }
      },
      "CHROME_EXTENSION": {
        "TITLE": "Extensión de Chrome",
        "NOTE": "Instala nuestra extensión de Chrome para recibir notificaciones enriquecidas sobre llamadas telefónicas entrantes.",
        "INSTALL_BUTTON": "Instalar extensión",
        "ALREADY_INSTALLED": "Extensión instalada"
      },
      "POSITION": {
        "LABEL": "Cargo",
        "ERROR": "Por favor, introduce un cargo válido",
        "PLACEHOLDER": "Por favor, introduce tu cargo"
      },
      "CUSTOM_LINE": {
        "LABEL": "Línea personalizada",
        "ERROR": "Por favor, introduce una línea personalizada válida",
        "PLACEHOLDER": "Por favor, introduce tu línea personalizada"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Cambiar",
    "CHANGE_ACCOUNTS": "Cambiar de cuenta",
    "SWITCH_ACCOUNT": "Cambiar de cuenta",
    "CONTACT_SUPPORT": "Contactar a soporte",
    "SELECTOR_SUBTITLE": "Seleccione una cuenta de la siguiente lista",
    "PROFILE_SETTINGS": "Ajustes del perfil",
    "KEYBOARD_SHORTCUTS": "Atajos de teclado",
    "APPEARANCE": "Cambiar apariencia",
    "SUPER_ADMIN_CONSOLE": "Consola SuperAdmin",
    "DOCS": "Leer la documentación",
    "LOGOUT": "Cerrar sesión",
    "REPORT_BUG": "Informar de un error"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "días de prueba restantes.",
    "TRAIL_BUTTON": "Comprar ahora",
    "DELETED_USER": "Usuario eliminado",
    "EMAIL_VERIFICATION_PENDING": "Parece que aún no has verificado tu dirección de correo electrónico. Por favor, revisa tu bandeja de entrada para ver el correo electrónico de verificación.",
    "RESEND_VERIFICATION_MAIL": "Reenviar correo de verificación",
    "EMAIL_VERIFICATION_SENT": "El correo electrónico de verificación ha sido enviado. Por favor, comprueba tu bandeja de entrada.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Cuenta suspendida",
      "MESSAGE": "Tu cuenta está suspendida. Comuníquese con el equipo de soporte para obtener más información."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copiar",
      "CODEPEN": "Abrir en Code Pen",
      "COPY_SUCCESSFUL": "Código copiado al portapapeles con éxito"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Mostrar más",
      "SHOW_LESS": "Mostrar menos"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Descargar",
      "UPLOADING": "Subiendo...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Esta historia ya no está disponible.",
      "RECORDING_UNAVAILABLE": "Esta grabación ya no está disponible.",
      "DELETE_RECORDING": {
        "BUTTON": "Eliminar grabación de la llamada",
        "TITLE": "¿Eliminar la grabación de la llamada?",
        "DESCRIPTION": "Todas las grabaciones de esta llamada se eliminarán de forma permanente de la centralita telefónica y no se podrán recuperar. La transcripción y el resumen de la llamada se conservan.",
        "CONFIRM": "Eliminar",
        "SUCCESS": "Grabación de la llamada eliminada",
        "ERROR": "No se pudo eliminar la grabación de la llamada. Inténtalo de nuevo."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Ver en el mapa"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Enviar"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Esta imagen ya no está disponible.",
      "LOADING_FAILED": "Error al cargar"
    }
  },
  "CONFIRM_EMAIL": "Verificando...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Añadir bandeja de entrada"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No hay elementos",
    "CURRENTLY_VIEWING_ACCOUNT": "Visualizando:",
    "SWITCH": "Cambiar",
    "INBOX_VIEW": "Vista del buzón",
    "CONVERSATIONS": "Conversaciones",
    "INBOX": "Mi bandeja de entrada",
    "ALL_CONVERSATIONS": "Todas las conversaciones",
    "MENTIONED_CONVERSATIONS": "Menciones",
    "PARTICIPATING_CONVERSATIONS": "Participar",
    "UNATTENDED_CONVERSATIONS": "Desatendido",
    "REPORTS": "Informes",
    "SETTINGS": "Ajustes",
    "CONTACTS": "Contactos",
    "CAPTAIN": "Capitán",
    "CAPTAIN_ASSISTANTS": "Asistentes",
    "CAPTAIN_DOCUMENTS": "Documentos",
    "CAPTAIN_RESPONSES": "Preguntas frecuentes",
    "HOME": "Inicio",
    "AGENTS": "Agentes",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Auditoría de registros",
    "INBOXES": "Entradas",
    "NOTIFICATIONS": "Notificaciones",
    "CANNED_RESPONSES": "Respuestas predefinidas",
    "INTEGRATIONS": "Integraciones",
    "PROFILE_SETTINGS": "Ajustes del perfil",
    "ACCOUNT_SETTINGS": "Configuración de la cuenta",
    "APPLICATIONS": "Aplicaciones",
    "LABELS": "Etiquetas",
    "CUSTOM_ATTRIBUTES": "Atributos personalizados",
    "AUTOMATION": "Automatización",
    "MACROS": "Macros",
    "TEAMS": "Equipos",
    "BILLING": "Facturación",
    "CUSTOM_VIEWS_FOLDER": "Carpetas",
    "CUSTOM_VIEWS_SEGMENTS": "Segmentos",
    "ALL_CONTACTS": "Todos los contactos",
    "TAGGED_WITH": "Etiquetado con",
    "NEW_LABEL": "Nueva etiqueta",
    "NEW_TEAM": "Nuevo equipo",
    "NEW_INBOX": "Nuevo buzón",
    "REPORTS_CONVERSATION": "Conversaciones",
    "CSAT": "Encuestas de Satisfacción",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Campañas",
    "ONGOING": "En Curso",
    "ONE_OFF": "One Off",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agentes",
    "REPORTS_LABEL": "Etiquetas",
    "REPORTS_INBOX": "Bandeja de entrada",
    "REPORTS_TEAM": "Equipo",
    "SET_AVAILABILITY_TITLE": "Ponte como",
    "SET_YOUR_AVAILABILITY": "Establecer su disponibilidad",
    "AVAILABILITY_IMPERSONATING": "Bloqueado mientras has iniciado sesión como este usuario",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Roles personalizados",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Resumen",
    "REAUTHORIZE": "Su sesión ha expirado, por favor, vuelva a conectarse para continuar recibiendo y enviando mensajes",
    "HELP_CENTER": {
      "TITLE": "Centro de ayuda",
      "ARTICLES": "Artículos",
      "CATEGORIES": "Categorías",
      "LOCALES": "Idiomas",
      "SETTINGS": "Ajustes",
      "DICTIONARY": "Diccionario"
    },
    "CHANNELS": "Canales",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Marcar como desconectado automáticamente",
      "INFO_TEXT": "Permite que el sistema te marque automáticamente sin conexión cuando no estás usando la aplicación o el tablero.",
      "INFO_SHORT": "Marcar automáticamente sin conexión cuando no está usando la aplicación."
    },
    "DOCS": "Leer documentos",
    "DATA_ASSISTANT": "Asistente de datos",
    "WHATSAPP_TEMPLATES": "Plantillas de WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "REPORTS_PHONE": "Teléfono",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Resumen",
    "WALLBOARD_QUEUES": "Colas",
    "WALLBOARD_AGENTS": "Resumen de agentes",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Informes",
    "NO_WAITING_CALLERS": "sin llamantes en espera",
    "WAITING_CALLERS": "{count} llamantes en espera",
    "NEW_CONVERSATION": "Nueva conversación",
    "DRAFT": "Borrador"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Facturación",
    "DESCRIPTION": "Gestiona tu suscripción aquí, mejora tu plan y consigue más para tu equipo.",
    "CURRENT_PLAN": {
      "TITLE": "Plan actual",
      "PLAN_NOTE": "Actualmente está suscrito al plan **{plan}** con **{quantity}** licencias",
      "SEAT_COUNT": "Número de asientos",
      "RENEWS_ON": "Renueva el"
    },
    "VIEW_PRICING": "Ver precios",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Administre su suscripción",
      "DESCRIPTION": "Vea sus facturas anteriores, edite sus datos de facturación o cancele su suscripción.",
      "BUTTON_TXT": "Ir al portal de facturación"
    },
    "CAPTAIN": {
      "TITLE": "Capitán",
      "DESCRIPTION": "Gestione el uso y los créditos para Captain AI.",
      "BUTTON_TXT": "Comprar más créditos",
      "DOCUMENTS": "Documentos",
      "RESPONSES": "Respuestas",
      "UPGRADE": "Captain no está disponible en el plan gratuito, actualice su suscripción ahora para tener acceso a asistentes, copilot y más."
    },
    "CHAT_WITH_US": {
      "TITLE": "¿Necesitas ayuda?",
      "DESCRIPTION": "¿Tienes a algún problema en la facturación? Estamos aquí para ayudarte.",
      "BUTTON_TXT": "Chatea con nosotros"
    },
    "NO_BILLING_USER": "Tu cuenta de facturación está siendo configurada. Por favor, actualiza la página e inténtalo de nuevo."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "¡Oh oh! No hemos podido encontrar ninguna cuenta. Por favor, crea una nueva cuenta para continuar.",
    "NEW_ACCOUNT": "Nueva cuenta",
    "SELECTOR_SUBTITLE": "Crear nueva cuenta",
    "API": {
      "SUCCESS_MESSAGE": "Cuenta creada con éxito",
      "EXIST_MESSAGE": "La cuenta ya existe",
      "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtelo de nuevo más tarde"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Empresa",
        "PLACEHOLDER": "Empresas de Wayne"
      },
      "SUBMIT": "Enviar",
      "CANCEL": "Cancelar"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Ver todos los accesos rápidos",
    "TITLE": {
      "OPEN_CONVERSATION": "Abrir conversación",
      "RESOLVE_AND_NEXT": "Resolver y pasar al siguiente",
      "NAVIGATE_DROPDOWN": "Navegar elementos desplegables",
      "RESOLVE_CONVERSATION": "Resolver conversación",
      "GO_TO_CONVERSATION_DASHBOARD": "Ir al panel de conversaciones",
      "ADD_ATTACHMENT": "Añadir archivo adjunto",
      "GO_TO_CONTACTS_DASHBOARD": "Ir al panel de contactos",
      "TOGGLE_SIDEBAR": "Cambiar barra lateral",
      "GO_TO_REPORTS_SIDEBAR": "Ir a la barra lateral de informes",
      "MOVE_TO_NEXT_TAB": "Mover a la siguiente pestaña en la lista de conversaciones",
      "GO_TO_SETTINGS": "Ir a Ajustes",
      "SWITCH_TO_PRIVATE_NOTE": "Cambiar a nota privada",
      "SWITCH_TO_REPLY": "Cambiar a respuesta",
      "TOGGLE_SNOOZE_DROPDOWN": "Cambiar el menú desplegable",
      "AI_ASSIST_MENU": "Asistencia IA",
      "AI_ASSIST_GRAMMAR": "Corregir gramática",
      "AI_ASSIST_UNIFY_LANG": "Unificar idioma del mensaje"
    }
  },
  "BUG_REPORT": {
    "TITLE": "Informar de un error",
    "DESCRIPTION_LABEL": "Descripción del problema",
    "DESCRIPTION_PLACEHOLDER": "Describe el problema que encontraste...",
    "SUBMIT": "Enviar informe",
    "SUBMITTING": "Enviando...",
    "CANCEL": "Cancelar",
    "SUCCESS": "Informe de error enviado correctamente. ¡Gracias!",
    "ERROR": "Error al enviar el informe de error. Por favor, inténtalo de nuevo.",
    "VALIDATION_ERROR": "Por favor, describe el problema antes de enviar"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Dominios y contactos bloqueados",
    "DESCRIPTION": "Lista de dominios de correo bloqueados para esta cuenta.",
    "NO_BLOCKED_DOMAINS": "No se encontraron dominios bloqueados.",
    "BLOCKED_CONTACTS_BTN": "Contactos bloqueados"
  }
}
